/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_3_AInputs */

const en_mk_faq_3_a = /** @type {(inputs: Mk_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent's work lands in In Review before it counts as done, and any outbound action — sending, posting, paying — waits for your approval in the Approval queue.`)
};

const id_mk_faq_3_a = /** @type {(inputs: Mk_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil kerja agen masuk status In Review sebelum dianggap selesai, dan aksi yang berdampak ke luar — kirim, posting, bayar — menunggu persetujuanmu di Approval.`)
};

/**
* | output |
* | --- |
* | "An agent's work lands in In Review before it counts as done, and any outbound action — sending, posting, paying — waits for your approval in the Approval queue." |
*
* @param {Mk_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_3_a = /** @type {((inputs?: Mk_Faq_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_3_a(inputs)
	return en_mk_faq_3_a(inputs)
});